export const TRANSLATIONS_FR_CHAT_TASKS_AND_PROFILE = {
  "tasks.process_document_a": "Traiter le document A",
  "tasks.extract_entities_a": "Extraction d'entités du document A",
  "tasks.classify_document_b": "Classer le document B",
  "tasks.classify_b_desc": "Classification automatique du document B",
  "tasks.index_document_c": "Indexer le document C",
  "tasks.index_c_desc": "Indexation du document C pour la recherche",
  "tasks.summarize_document_d": "Résumer le document D",
  "tasks.summarize_d_desc": "Génération automatique de résumé",
  "chat.title": "Assistant de Documents",
  "chat.grounding.evidence.aria": "État des preuves",
  "chat.grounding.evidence.grounded": "Appuyé sur les documents",
  "chat.grounding.evidence.partially_grounded": "Appui partiel",
  "chat.grounding.evidence.no_evidence": "Aucune preuve documentaire",
  "chat.grounding.evidence.validation_failed": "Impossible de valider les preuves",
  "chat.grounding.evidence.retrieval_failed": "Impossible de récupérer les preuves",
  "chat.grounding.evidence.unknown": "Preuve indéterminée",
  // Avertissements (P2-1) : `retrieval_failed` n'est PAS `no_evidence` — rien n'a été
  // récupéré à cause d'une panne, ce qui n'est pas la même chose qu'il n'y ait rien.
  "chat.grounding.evidence.warning.partially_grounded": "Cette réponse ne s'appuie que sur une partie des preuves disponibles et peut être incomplète. Vérifiez les sources avant d'utiliser des chiffres ou des dates.",
  "chat.grounding.evidence.warning.no_evidence": "Aucun document n'a été récupéré pour cette question : cette réponse n'est pas étayée par vos documents.",
  "chat.grounding.evidence.warning.validation_failed": "Il n'a pas pu être validé que cette réponse correspond aux documents récupérés. Vérifiez les sources avant d'utiliser des chiffres ou des dates.",
  "chat.grounding.evidence.warning.retrieval_failed": "Les preuves n'ont pas pu être récupérées en raison d'une erreur système. Cette réponse n'est pas étayée par vos documents ; veuillez réessayer.",
  "chat.generation.proposal.generateHere": "Générer ici",
  "chat.generation.enqueued": "Votre résumé est en cours de traitement. Cliquez ici pour voir l'avancement.",
  "chat.generation.viewProgress": "Voir dans Documents Générés",
  "chat.generation.forbidden": "Votre forfait ne permet pas de générer des résumés ou le quota est atteint.",
  "chat.generation.error": "La génération n'a pas pu être mise en file d'attente.",
  "chat.generation.proposal.button": "Générer un résumé exécutif",
  "chat.generation.proposal.fallback": "Je peux générer un résumé exécutif de vos documents. Je le fais ?",
  "chat.generation.generateSummary": "Générer un résumé",
  "chat.generation.defaultHint": "Génère un résumé exécutif de mes documents",
  "chat.plus.menuLabel": "Actions",
  "chat.plus.modeSection": "Type de recherche",
  "chat.generation.candidatesQuestion": "J'ai trouvé ces documents pour votre résumé. Dois-je le générer avec eux ?",
  "chat.generation.proposal.confirm": "Oui, générer le résumé",
  "chat.generation.proposal.adjust": "Ajuster dans l'assistant",
  "chat.generation.unnamedDoc": "Document",
  "chat.generation.armedPlaceholder": "Décrivez le résumé que vous souhaitez générer…",
  "chat.generation.armedCancel": "Annuler Générer un résumé",
  "chat.placeholder": "Écrivez votre message...",
  "chat.send": "Envoyer",
  "chat.sources": "Sources",
  // `score` est la similarité cosinus du retrieval, pas une mesure de confiance.
  "chat.relevance": "Pertinence",
  "chat.error.unsupportedQuestion": "Désolé, je n'ai pas compris le type de question. Pourriez-vous me donner plus de contexte ou de détails ?",
  "chat.error.unexpected": "Une erreur inattendue s'est produite.",
  "chat.error.unknownResponse": "Réponse inconnue du système.",
  "chat.download": "Télécharger",
  "chat.feedback": "Cette réponse a-t-elle été utile ?",
  "chat.yes": "Oui",
  "chat.no": "Non",
  "chat.feedback_comment": "Ajoutez un commentaire (optionnel)",
  "chat.feedback_thanks": "Merci pour votre retour !",
  "chat.clear": "Effacer le chat",
  "chat.show_details": "Voir les détails",
  "chat.hide_details": "Masquer les détails",
  "chat.selected_source": "Source sélectionnée",
  "chat.location": "Emplacement",
  "chat.chunk": "Extrait",
  "chat.typing": "Saisie...",
  "chat.input_placeholder": "Posez une question",
  "chat.edit_message": "Éditer le message",
  "chat.edit": "Éditer",
  "chat.copy_message": "Copier le message",
  "chat.like_message": "J'aime",
  "chat.dislike_message": "Je n'aime pas",
  "chat.deselect_message": "Désélectionner le message",
  "chat.copied": "Copié",
  "chat.download_document": "Télécharger le document",
  "chat.documents": "Documents",
  "chat.document": "Document",
  "chat.double_click_hint": "Double-cliquez pour voir les sources",
  "chat.click_to_read_source": "Cliquez pour lire cette source",
  "chat.fragment_text": "Extrait cité",
  "chat.star_rating_title": "{{count}} étoiles",
  "chat.downloaded": "Téléchargé",
  "chat.close_detail": "Fermer le détail",
  "chat.session_name_empty_error": "Le nom ne peut pas être vide.",
  "chat.session_untitled": "Session sans nom",
  "chat.rename": "Renommer",
  "chat.save": "Enregistrer",
  "chat.cancel": "Annuler",
  "chat.no_previous_sessions": "Aucune session précédente.",
  "chat.recover": "Récupérer la réponse",
  "chat.new_session": "Nouvelle session",
  "chat.close": "Fermer",
  "chat.message_change_name_success":
    "Le nom du chat est mis à jour correctement",
  "chat.search_type": "Type de recherche",
  "chat.search_type.light": "Légère",
  "chat.search_type.default": "Par défaut",
  "chat.search_type.medium": "Moyen",
  "chat.search_type.strong": "Fort",
  "tasks.pending": "Tâches en attente",
  "tasks.processed": "Tâches traitées",
  "tasks.created": "Tâches créées",
  "tasks.processed_at": "Traitée le",
  "tasks.loading": "Chargement des tâches...",
  "tasks.status": "Statut",
  "tasks.steps": "Étapes",
  "tasks.description": "Description",
  "tasks.created_by": "Créée par",
  "tasks.no_processed": "Aucune tâche traitée.",
  "tasks.filters": "Filtres",
  "tasks.filter_by_id": "Filtrer par ID de tâche",
  "tasks.filter_by_date": "Filtrer par date",
  "tasks.clear_filters": "Effacer les filtres",
  "tasks.no_pending": "Aucune tâche en attente.",
  "profile.name": "Nom",
  "profile.email": "E-mail",
  "profile.company": "Entreprise",
  "profile.role": "Rôle",
  "profile.title": "Profil",
  "profile.section_personal": "Informations personnelles",
  "profile.section_organization": "Organisation",
  "profile.country": "Pays",
  "profile.country_select": "Sélectionnez un pays",
  "profile.section_preferences": "Préférences",
  "profile.email_managed": "E-mail géré par le système",
  "profile.role_managed": "Rôle géré par le système",
  "profile.job_title": "Poste",
  "profile.organization_type": "Type d'organisation",
  "profile.organization_size": "Taille de l'organisation",
  "profile.loading": "Chargement du profil...",
  "profile.loading_data": "Chargement des données du profil...",
  "profile.save": "Enregistrer le profil",
  "profile.save_success": "Profil enregistré avec succès.",
  "chat.inputmode_question": "Obtenir des informations du document",
  "chat.inputmode_csv": "Requête CSV",
  "chat.inputmode_db": "Requête base de données",
  "chat.inputmode_count_documents": "Comptage de documents",
  "chat.no_sessions": "Aucune session",
  "chat.tools": "Outils",
  "chat.expertRole.label": "Répondre en tant que…",
  "chat.expertRole.placeholder": "Aucun rôle",
  "chat.expertRole.clear": "Retirer l'expert",
  "chat.expertRole.applied": "Répondu en tant que",
  "chat.expertRole.notEntitled": "Votre forfait n'inclut pas les rôles experts",
  "chat.expertRole.degraded": "Le rôle sélectionné n'a pas été appliqué à cette réponse.",
  "chat.expertRole.messageBadge": "Consultation avec expert",
  "profile.change_photo": "Changer la photo",
  "profile.name_required": "Le nom est obligatoire.",
  "profile.load_error": "Erreur lors du chargement du profil.",
  "profile.photo_upload_error": "Erreur lors du téléversement de la photo.",
  "profile.save_error": "Erreur lors de l'enregistrement du profil.",
  "tasks.filter_by_status": "Filtrer par statut",
  "tasks.filter_by_user": "Filtrer par utilisateur",
  "tasks.filter_by_description": "Filtrer par description",
  "tasks.step": "Étape",
};
